import React, { useContext } from 'react';
import { TraitsCtx } from 'pages/TraitsPage';
import SearchBar from '../../basic/SearchBar';

const TraitsSearchBar = (_props) => {
  const { search, setSearch } = useContext(TraitsCtx);
  const onChange = (value) => {
    setSearch(value);
  };
  return <SearchBar placeholder='Search in Traits' value={ search } onChange={ onChange } />;
};

export default TraitsSearchBar;
